import React from "react";
import ModalPage from "../../../../layout/ModalPage";
import { useDispatch, useSelector } from "react-redux";
import { startConfirmarProveedor } from "../../../../context/actions/asistenciasActions";
import { FormaAceptarServicio } from "./_FormaAceptarServicio";

export const ModalLocal = ({ open, setOpen, asistencia }) => {
  const dispatch = useDispatch();
  const loadingConfirmarProveedor = useSelector(state => state.asistenciasReducer.loadingConfirmarProveedor);

  const handleOk = () => {
    dispatch(startConfirmarProveedor(asistencia.asistenciaID, asistencia));

    if (asistencia.esGnpApi)
      dispatch({
        folioAsignacion: asistencia.folioGnp,
        estatusActual: "EA",
      });
  };


  return (
    <ModalPage
      handleOk={handleOk}
      handleCancel={() => setOpen(false)}
      isVisible={open}
      titulo="Tomar Servicio - LOCAL"
      okLabel="Aceptar Servicio"
      loadingOk={loadingConfirmarProveedor}
    >
      <FormaAceptarServicio />
    </ModalPage>
  );
};
